import { Button, ButtonProps, Tooltip } from 'antd';
import React, { PropsWithChildren } from 'react';

interface CustomButtonProps extends ButtonProps {
  tooltip?: string;
  open?: boolean;
}

export default function CustomButton(
  props: PropsWithChildren<CustomButtonProps>
) {
  const ButtonElement = <Button {...props}>{props.children}</Button>;

  if (props.tooltip) {
    return (
      <Tooltip arrow={false} title={props.tooltip} open={props.open}>
        {ButtonElement}
      </Tooltip>
    );
  }

  return ButtonElement;
}
